import React from 'react';
import Divider from 'material-ui/Divider';
import { cdnPath } from '../constants/config';

class Benefits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
    }

    render() {
        const net = this.props.net;

        const style = {
            labels:{
                fontSize: "38px",
                color: "#828282",
            },
            data:{
                size: "38px",
                color: "#333333",
            },
            lightText: {
                color: "#999999",
            }
        }

        return (

            <div>
                <div>
                    {this.props.plan.Networks[0].LogoUrl && (
                        <div >
                            <img src={`https://${cdnPath}/networkimages/` + this.props.plan.Networks[0].LogoUrl} style={{height:40, paddingBottom: 5}} />
                            <Divider style={{ width: '100%', margin:'5px 0 5px 0' }} />
                        </div>
                    )}
                
                <table>
                    <tr style={{height: 34}}>
                        <td><span className= {"truenoLight"} style={style.lightText}>Plan</span></td>
                        <td><span className={"trueno semiBold"} style={style.label}>{this.props.plan.Name}</span></td>
                    </tr>
                    <tr style={{height: 34}}>
                        <td className= {"truenoLight"} style={style.lightText}>Network</td>
                        <td><span className={"trueno semiBold"} style={style.label}>{this.props.plan.Networks[0].Name}</span></td>
                    </tr>
                {/* </table>
                <table> */}
                    {this.props.net.Benefits && this.props.net.Benefits.map((ben, index) => (
                        <tr key={index} style={{height: 34}}>
                                <td><span className= {"truenoLight"} style={style.lightText}>{ben.Name}</span></td>
                                <td><span className={"trueno semiBold"} style={style.label}>{ben.Description}</span></td>
                        </tr>
                    ))}
                </table>
            </div>
            </div>
        );
    }
};

export default Benefits;




// WEBPACK FOOTER //
// ./src/Components/Benefits.js